import React, { useState } from "react";
import { IoIosInformationCircleOutline } from "react-icons/io";
import Input from "../../../ui/Input/Input";
import Modal from "../../../ui/Modal/Modal";

import "./Closed.css";

function Closed({ question, onUpdateAnswer, invalidKeys }) {
  const [selectedAnswer, setSelectedAnswer] = useState(-1);
  const [isOtherSelected, setIsOtherSelected] = useState(false);
  const [otherText, setOtherText] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const isInvalid = invalidKeys.includes(question.key);

  function onSelectAnswer(itemData) {
    setIsOtherSelected(false);
    setOtherText("");
    const answer = {
      key: question.key,
      answer: itemData.item.title,
      question: question.description,
      type: question.answersType,
    };
    onUpdateAnswer(answer);
    setSelectedAnswer(itemData.item.key);
  }

  function onSelectOther() {
    setIsOtherSelected(true);
    setSelectedAnswer(question.answers.length);
  }

  function updateOtherTextHandler(e) {
    const enteredValue = e.target.value;
    setOtherText(enteredValue);
    const answer = {
      key: question.key,
      answer: enteredValue,
      question: question.description,
      type: question.answersType,
    };
    onUpdateAnswer(answer);
  }

  function LoadSingleAnswer(itemData) {
    return (
      <div
        className={
          selectedAnswer === itemData.item.key
            ? "buttonSelected"
            : "groupButton"
        }
        onClick={onSelectAnswer.bind(this, itemData)}
      >
        <div>
          <p className="buttonText">{itemData.item.title}</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <Modal isOpen={modalVisible} onClose={() => setModalVisible(false)}>
        <div style={{
          backgroundColor: "",
        }}>
          {question.modalTexts &&
            question.modalTexts.map((t) => {
              return (
                <p
                  key={t.key}
                >
                  {t.value}
                </p>
              );
            })}
        </div>

      </Modal>


      <div className={isInvalid ? "error" : "mainClosed"}>
        <p className="question">{question.description}</p>
        {question.haveModal && (
          <div>
            <IoIosInformationCircleOutline
              style={{ fontSize: "20px", padding: "8px", color: "white" }}
              onClick={() => { setModalVisible(true) }}
            />
          </div>
        )}
        {question.answers.map((question) => {
          return <LoadSingleAnswer key={question.key} item={question} />;
        })}
        {question.canBeOpen && (
          <div>
            <div
              className={
                selectedAnswer === question.answers.length
                  ? "buttonSelected"
                  : "groupButton"
              }
              onClick={onSelectOther}
            >
              <div>
                <p className="buttonText">
                  {question.openText ? question.openText : "Otro"}
                </p>
              </div>
            </div>
            {isOtherSelected && (
              <div>
                <Input
                  label="Especifique:"
                  onUpdateValue={updateOtherTextHandler.bind(this)}
                  value={otherText}
                  autoCompleteType="off"
                />
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default Closed;
